// @ts-check
import { Bar, BarChart, Cell, XAxis, YAxis } from 'recharts';
import BlockCard from '../BlockCard';
import { WHATSAPP_CAMPAIGN_STATUS as S } from '../../../utils/whatsapp';

const STATUSES = [
  [S.DRAFT, 'Draft', '#94a3b8'],
  [S.SCHEDULED, 'Scheduled', '#3b82f6'],
  [S.SENDING, 'Sending', '#f59e0b'],
  [S.COMPLETED, 'Done', '#22c55e'],
  [S.CANCELLED, 'Cancelled', '#ef4444'],
];

/** Unread customer conversations (headline) beside a campaigns-per-status bar chart. */
export default function WhatsAppBlock({ block }) {
  const { unread_conversations: unread = 0, oldest_unread_hours: oldest = null, campaigns_by_status: byStatus = {} } = block.data || {};
  const bars = STATUSES.map(([key, name, fill]) => ({ name, fill, value: byStatus[key] || 0 }));
  const hasCampaigns = bars.some((b) => b.value > 0);

  return (
    <BlockCard title="WhatsApp" href={block.href} headline={block.headline}>
      {hasCampaigns ? (
        <div data-testid="whatsapp-chart" className="overflow-x-auto">
          <p className="text-xs text-muted-foreground">Campaigns by status</p>
          <BarChart width={260} height={110} data={bars} aria-hidden="true">
            <XAxis dataKey="name" tickLine={false} axisLine={false} fontSize={11} />
            <YAxis hide allowDecimals={false} />
            <Bar dataKey="value" isAnimationActive={false}>
              {bars.map((b) => (
                <Cell key={b.name} fill={b.fill} />
              ))}
            </Bar>
          </BarChart>
        </div>
      ) : (
        unread === 0 && <p className="text-sm text-muted-foreground">No WhatsApp activity yet</p>
      )}
      {unread > 0 && oldest !== null && (
        <p data-testid="whatsapp-oldest" className="mt-2 text-sm text-muted-foreground">Oldest unread {oldest}h</p>
      )}
    </BlockCard>
  );
}
